import React from 'react';

const SVGClose = props => {
  return (
    <div className="svg svg--stroke svg--square-stroke">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.26 16.26">
        <title>Close</title>
        <path className="cls-1" d="M15.56.71.71,15.56" />
        <path className="cls-1" d="M15.56,15.56.71.71" />
      </svg>
    </div>
  );
};

export default SVGClose;



// WEBPACK FOOTER //
// ./src/svg/Close.js